import { TextField, Grid, Typography } from '@material-ui/core'
import CommentIcon from '@material-ui/icons/Comment'
import SubmitButton from './Button'

const Form = ({ onInputChange, onButtonClick, nameValue, emailValue, phoneValue, messageValue }) => {
  return (
    <Grid
      id='contact-form' className='contact-form-container'
    >
      <Grid item xs={10} sm={5}>
        <Typography variant='h3' gutterBottom>
          <CommentIcon className='contact-form-icon' /> Ota yhteyttä
        </Typography>
      </Grid>
      <Grid item xs={10} sm={5}>
        <TextField
          id='name'
          label='Nimi'
          name='name'
          value={nameValue}
          onChange={onInputChange}
          variant='outlined'
          fullWidth
        />
      </Grid>
      <Grid item xs={10} sm={5}>
        <TextField
          id='email'
          label='Sähköpostiosoite'
          name='email'
          value={emailValue}
          onChange={onInputChange}
          variant='outlined'
          fullWidth
        />
      </Grid>
      <Grid item xs={10} sm={5}>
        <TextField
          id='phone'
          label='Puhelinnumero'
          name='phone'
          value={phoneValue}
          onChange={onInputChange}
          variant='outlined'
          fullWidth
        />
      </Grid>
      <Grid item xs={10} sm={5}>
        <TextField
          id='message'
          label='Vapaa teksti'
          name='message'
          value={messageValue}
          rows={6}
          multiline
          onChange={onInputChange}
          variant='outlined'
          fullWidth
        />
      </Grid>
      <Grid item xs={10} sm={5}>
        <SubmitButton
          onButtonClick={onButtonClick}
        />
      </Grid>
    </Grid>
  )
}

export default Form
